import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'japanDate',
})
export class JapanDatePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    try {
      const date = new Date(value);

      // Check value is valid date
      if (isNaN(date.getTime())) {
        return value;
      }

      // Format the date in the Japanese standard: YYYY年MM月DD日 HH:MM:SS
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      return `${year}年${month}月${day}日 ${hours}:${minutes}`;
    } catch (error) {
      return value;
    }
  }
}
